// Bascule automatique en menu burger dès que le menu toucherait le logo
// (demande Rudy, 11 octobre 2026). Un seuil fixe ne marchait pas : la
// largeur du menu dépend du mode admin (Dashboard/Déconnecter en plus,
// burger nécessaire sous ~1314px contre ~1076px en public) et de la police
// réellement disponible (Futura sur Mac, remplacée ailleurs).
//
// Chargé en <script> synchrone juste après </header> sur chaque page :
// la classe est posée avant le premier affichage, sans flash du menu
// par-dessus le logo.
(() => {
  const header = document.querySelector('header');
  const nav = header?.querySelector('.header-nav');
  const logo = header?.querySelector('#headerLogo svg') || header?.querySelector('#headerLogo');
  if (!nav || !logo) return;

  const MIN_GAP_PX = 24;
  // En dessous, le logo est centré (cf. style.css) : burger dans tous les cas.
  const ALWAYS_BURGER_MAX_WIDTH = 600;

  function update() {
    let burger = window.innerWidth <= ALWAYS_BURGER_MAX_WIDTH;
    if (!burger) {
      // Mesure du menu "à plat" : on retire la classe le temps de la mesure
      // (même tâche, aucun affichage entre les deux).
      const wasBurger = header.classList.contains('header--burger');
      header.classList.remove('header--burger');
      const navRect = nav.getBoundingClientRect();
      const logoRect = logo.getBoundingClientRect();
      if (navRect.width === 0 || logoRect.width === 0) {
        // Header masqué (caméra AR, plein écran...) : rien à mesurer.
        header.classList.toggle('header--burger', wasBurger);
        return;
      }
      burger = navRect.left < logoRect.right + MIN_GAP_PX;
    }
    header.classList.toggle('header--burger', burger);
    if (!burger) header.classList.remove('nav-open');
  }

  update();
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(header);
  else window.addEventListener('resize', update);
  // Liens Dashboard/Déconnecter/Installer l'app affichés ou masqués après
  // coup (vérification admin, détection PWA) : la largeur du menu change.
  new MutationObserver(update).observe(nav, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
  document.fonts?.ready.then(update);
})();
